import React from 'react'
import useContentPlayerContext from 'context/content-player'

export default function AssignmentUsersColPrasyarat({ item }) {
  /* ====================================== Consume Context ===================================== */
  const { content } = useContentPlayerContext()

  /* ========================================= Constants ======================================== */
  const _isFeedbackRequired      = content.feedback
  const _isKomentarTugasRequired = content.komentar_tugas && content.komentar_wajib > 0
  const _isGrupKecilRequired     = content.group_status
  const _isFeedbackPassed        = content.feed?.feed_temps.find((ft) => ft.content_id === content.id && ft.user_id === item.id)
  const _isKomentarTugasPassed   = item?.komentar_tugas_count >= content.komentar_wajib
  const _isGrupKecilPassed       = item?.grup_kecil_passed

  /* ========================================== Output ========================================== */
  return (
    (_isFeedbackRequired ||
      _isKomentarTugasRequired ||
      _isGrupKecilRequired) && (
      <td>
        {_isFeedbackRequired && (
          <div
            className={`mr-1 badge badge-${
              _isFeedbackPassed ? 'success' : 'danger'
            }`}
          >
            {_isFeedbackPassed ? 'Sudah' : 'Belum'} Feedback
          </div>
        )}
        {_isKomentarTugasRequired && (
          <div
            className={`mr-1 badge badge-${
              _isKomentarTugasPassed ? 'success' : 'danger'
            }`}
          >
            {_isKomentarTugasPassed ? 'Sudah' : 'Belum'} Komentar Tugas
          </div>
        )}
        {_isGrupKecilRequired && (
          <div
            className={`mr-1 badge badge-${
              _isGrupKecilPassed ? 'success' : 'danger'
            }`}
          >
            {_isGrupKecilPassed ? 'Sudah' : 'Belum'} Grup Kecil
          </div>
        )}
      </td>
    )
  )
}
